import { type EventData, type EventPayload, type EventType } from './defn';

// data should be | separated types as this is meant to be a generic function
export const sendEvent = (type: EventType, data: EventPayload) => {
  if (typeof window !== 'undefined') {
    const message: EventData = {
      source: 'pricify',
      type,
      payload: data,
    };
    try {
      console.log('Sending message to parent window', message);
      window.parent.postMessage(message, '*');
    } catch (e) {
      console.error('Error sending message to parent window', { error: e });
    }
  }
};
